







































































































































































































































import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'VaimoIconSVG',

  props: {
    iconName: {
      type: String,
      required: true,
      validator: (value: string) =>
        [
          'account',
          'bagempty',
          'search',
          'burger-menu',
          'cross',
          'logo'
        ].includes(value)
    },
    size: { type: Number, default: 24 },
    label: { type: String, default: '' },
    role: { type: String, default: '' }
  }
});
